export default __webpack_public_path__ + "static/media/free-medical-missions.83c7acbe.jpg";